import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState, FORM_MODE, AppNotifications, TCb, BranchOutputModel } from "../../../../../models";
import { C_Props, C_States, MapDispatchToProps, MapStateToProps, MergedProps } from "./BranchForm.type";
import { withRouter } from "react-router-dom";
import { NotificationActions } from "../../../../../store/actions";
import BranchFormPresenter from "./BranchForm.presenter";
import { loadCallback } from "../../../../../utils";
import { NetWorkService, BlogService } from "../../../../../services";
class BranchFormContainer extends Component<MergedProps, C_States> {
  constructor(props) {
    super(props);
    this.state = {
      mode: FORM_MODE.CREATE,
      loading: false,
      initData: null,
      allLabels: this.props.all_labels.data,
      tags: [],
      tag: ""
    };
  }

  handleKeyDown = (e) => {
    if (["Enter", "Tab"].includes(e.key)) {
      e.preventDefault();

      var value = this.state.tag.trim();

      if (value) {
        this.setState({
          tags: [...this.state.tags, this.state.tag],
          tag: ""
        });
      }
    }
  };

  handleChange = (e) => {
    this.setState({
      tag: e.target.value,
    });
  };

  handleRemoveTag = (item) => {
    this.setState({
      tags: this.state.tags.filter((i) => i !== item)
    });
  };

  onSubmit = (val: any) => {
    let data = {
      ...val,
      contact: this.state.tags,
      countryId: this.props.countryId,
      branchId: this.props.branchId
    };

    if (this.state.mode === FORM_MODE.CREATE) {
      this.onCreateBranch(data);
    } else {
      this.onUpdateBranch(data);
    }
  };

  onCreateTag = (name: string, cb?: TCb) => {
    if (!name) {
      return;
    }

    BlogService.createLabel({ name: name }) // doi lai service
      .then((res) => {
        if (res && (res.status === 201 || res.status === 200)) {
          this.props.actions.getAllLabels();
          loadCallback(cb?.success, { name, id: res.data.data.id });
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create label failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create label failed" });
      });
  };

  onCreateBranch = (data) => {
    NetWorkService.createBranch(data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Create branch success",
          });
          loadCallback(this.props.onComplete_Create);
        } else {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Create branch failed",
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Create branch failed",
        });
      });
  };

  onUpdateBranch = (data) => {
    NetWorkService.updateBranch(this.props.branchId!, data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Update branch success",
          });
          loadCallback(this.props.onComplete_Update);
        } else {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Update branch failed",
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Update branch failed",
        });
      });
  };

  onLoadBranchDetail = (branchId: string, cb?: TCb) => {
    this.setState({ loading: true, initData: null }, () => {
      NetWorkService.getBranchDetail(branchId)
        .then((res) => {
          if (res && (res.status === 200 || res.status === 201)) {
            const data: BranchOutputModel = res.data.data;

            this.setState(
              {
                mode: FORM_MODE.EDIT,
                loading: false,
                initData: data,
                tags: data.contact
              },
              () => {
                loadCallback(cb?.success);
              }
            );
          } else {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Failed to load data",
            });
            this.props.history.goBack();
          }
        })
        .catch((err) => {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Failed to load data",
          });
        });
    });
  };

  componentDidMount = () => {
    if (this.props.branchId) {
      this.onLoadBranchDetail(this.props.branchId, {
        success: () => { },
      });
    }
  }

  render() {
    return (
      <>
        <BranchFormPresenter
          {...this.props}
          {...this.state}
          onSubmit={this.onSubmit}
          onCreateTag={this.onCreateTag}
          handleChange={this.handleChange}
          handleKeyDown={this.handleKeyDown}
          handleRemoveTag={this.handleRemoveTag}
          // handleTagsChange={this.handleTagsChange}
        />
      </>
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,
      all_labels: state.all_labels,
    }),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions), dispatch),
    })
  )(BranchFormContainer)
);
